import BASE_URL from "../config";

// Coupons currently redeemable against a product — shown below the product.
export const getCouponsForProduct = async (productId) => {
  const response = await fetch(`${BASE_URL}/coupons/product/${productId}`);
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

// Preview a coupon's discount against a set of items before checkout.
// Pass the access token so login-only coupons can recognise the customer.
export const validateCoupon = async (code, items, token) => {
  const response = await fetch(`${BASE_URL}/coupons/validate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ code, items }),
  });
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

// The login-reward coupon the "log in for a discount" pop-up advertises
// (null when the admin has none active).
export const getLoginOffer = async () => {
  try {
    const response = await fetch(`${BASE_URL}/coupons/login-offer`);
    const result = await response.json().catch(() => ({}));
    return { ok: response.ok, ...result };
  } catch {
    return { ok: false, data: null };
  }
};
